import React from "react";
import { useSiteContent } from "@/contexts/SiteContentContext";

export default function SiteFooter() {
    const { t } = useSiteContent();
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-magni-light bg-magni-cream"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-magni-muted">
                <div>
                    <div className="overline mb-3">{t("footer.col1.title", "Magniflex")}</div>
                    <p className="whitespace-pre-line">
                        {t(
                            "footer.col1.body",
                            "L'eccellenza italiana del riposo dal 1962. MagniStretch® è il materasso che si allunga con te.",
                        )}
                    </p>
                </div>
                <div>
                    <div className="overline mb-3">{t("footer.col2.title", "L'esperienza in negozio")}</div>
                    <p className="whitespace-pre-line">
                        {t(
                            "footer.col2.body",
                            "Una sessione di prova gratuita presso un rivenditore autorizzato Magniflex. Ti aspettiamo.",
                        )}
                    </p>
                </div>
                <div>
                    <div className="overline mb-3">{t("footer.col3.title", "Contatti")}</div>
                    <p className="whitespace-pre-line">
                        {t("footer.col3.body", "magniflex.com\nToscana, Italia")}
                    </p>
                </div>
            </div>
            <div className="border-t border-magni-light">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-xs text-magni-muted">
                    © {new Date().getFullYear()} Magniflex S.p.A. — Tutti i diritti
                    riservati.
                </div>
            </div>
        </footer>
    );
}
